import { hooks } from "./hooks";
import { utils } from "./utils";

export const api = {
  utils,
  hooks,
};
